import { HashRouter, NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { logout, tokens } from './api'
import Homes from './pages/Homes'
import Home from './pages/Home'
import Thermostat from './pages/Thermostat'
import Billing from './pages/Billing'
import Audit from './pages/Audit'
import Login from './pages/Login'

function Shell() {
  const [, force] = useState(0)
  useEffect(() => {
    // The API client clears tokens and redirects on an unrecoverable 401;
    // re-render so the shell drops to the login screen rather than showing
    // panels that will never load.
    const onHash = () => force((n) => n + 1)
    window.addEventListener('hashchange', onHash)
    return () => window.removeEventListener('hashchange', onHash)
  }, [])

  if (!tokens.access) return <Navigate to="/login" replace />

  const link = ({ isActive }: { isActive: boolean }) => (isActive ? 'on' : '')
  return (
    <div className="shell">
      <nav className="side">
        <div className="brand"><span className="dot" /> Therm</div>
        {/* Three sections, not seven. History, insights and the control
            audit trail are properties of a thermostat, so they live inside
            one rather than beside it. */}
        <NavLink to="/homes" className={link}>Homes</NavLink>
        <NavLink to="/billing" className={link}>Billing</NavLink>
        <NavLink to="/audit" className={link}>Audit</NavLink>
        <div className="spacer" />
        <button
          className="btn ghost"
          onClick={async () => { await logout(); window.location.hash = '#/login' }}
        >
          Sign out
        </button>
      </nav>
      <main>
        <Routes>
          <Route path="/homes" element={<Homes />} />
          <Route path="/homes/:homeId" element={<Home />} />
          <Route path="/homes/:homeId/t/:deviceId" element={<Thermostat />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="*" element={<Navigate to="/homes" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Shell />} />
      </Routes>
    </HashRouter>
  )
}
